import React from 'react';
import {withRouter} from 'react-router-dom';
import {connect} from 'react-redux';
import {bindActionCreators} from "redux";
import Timer from 'react-compound-timer';

import {Input, LinkButton, Button, Validator, Notification} from 'components/common/uiKit';
import {UserApi} from 'services/network/api';
import {serverUrl} from 'services/network';
import {stringFormat} from 'services/converts/strings';
import {convertDigitsToStandard} from 'services/converts/numbers';
import {AvatarAction} from 'services/redux/actions';

const time = 60 * 1000;

class Verify extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            sendAgain: false,
            mobile: '',
            registered: false,
            verifyCode: '',
            fullName: '',
            submitLoading: false
        };

        this.validator = Validator(props.locale.abbreviation);
    }

    componentDidMount() {
        this.checkParams();
    }

    checkParams() {
        const params = this.props.location.state;

        if (!params || !params.mobile || typeof (params.registered) != 'boolean') {
            const {history} = this.props;

            history.push({
                pathname: 'register',
                search: '',
                state: ''
            });

            Notification('error', 'WrongParams');
        } else {
            this.setState({mobile: params.mobile, registered: params.registered});
        }
    }

    endOfTimer = () => {
        this.setState({sendAgain: true});
    };

    handleInputChange = name => event => {
        this.setState({[name]: convertDigitsToStandard(event.target.value)});
    };

    verifyOnClick = () => {
        const {mobile, verifyCode, fullName, registered} = this.state;
        const {locale} = this.props;
        const pageTranslates = locale.translation.Pages.Register.Verify;

        this.setState({submitLoading: true});

        let validationResult = true;
        validationResult = this.validator.fieldValid(pageTranslates.VerifyCode);
        validationResult = (validationResult && registered) ? true : this.validator.fieldValid(pageTranslates.FullName);

        if (validationResult && mobile) {
            const {history, locale} = this.props;

            const model = {mobile, verifyCode, fullName, localeId: locale.id};
            UserApi.Verify(model)
                .then(res => {
                    if (res && res.status == 200) {
                        const {data} = res;

                        model.token = data.token;

                        let user = {
                            mobile: model.mobile,
                            token: data.token,
                            fullName: data.fullName
                        };

                        if (data.avatar) {
                            const avatar = serverUrl + data.avatar;
                            Object.assign(user, {avatar: avatar});

                            const {actions} = this.props;
                            actions.setAvatar(avatar);
                        }

                        this.addToLocalStorage(user);

                        history.replace({
                            pathname: '/app',
                        });
                    }
                })
                .finally(x => {
                    this.setState({submitLoading: false});
                });
        } else {
            this.validator.showMessages();
            this.forceUpdate();
            Notification('error', 'WrongData');
            this.setState({submitLoading: false});
        }
    };

    addToLocalStorage(model) {
        localStorage.removeItem('user');
        localStorage.setItem('user', JSON.stringify(model));
    }

    sendAgainOnClick = () => {
        const {mobile} = this.state;
        if (mobile) {
            this.setState({submitLoading: true});

            UserApi.SendVerifyAgain({mobile})
                .then(res => {
                    if (res && res.status == 200) {
                        //TODO: Reset timer
                        this.setState({sendAgain: false});
                    }
                })
                .finally(x => {
                    this.setState({submitLoading: false});
                });
        }
    };

    render() {
        const {sendAgain, submitLoading, mobile, registered} = this.state;
        const {verifyCode, fullName} = this.state;

        const {locale} = this.props;
        const pageTranslates = locale.translation.Pages.Register.Verify;

        return (
            <div className="card card-style" style={{marginTop: 20}}>
                <div className='register-page-title' style={{marginTop: 10}}>
                    <h2 className='text-center color-primary'>
                        {pageTranslates.Title}
                    </h2>
                </div>
                <div className="content mt-2 mb-0">
                    <Input placeholder={pageTranslates.VerifyCode} value={verifyCode} type='tel' pattern="\d*"
                           onChange={this.handleInputChange('verifyCode')}/>
                    {this.validator.message(pageTranslates.VerifyCode, verifyCode, 'required|size:6|integer')}

                    {!registered &&
                    <>
                        <Input placeholder={pageTranslates.FullName} value={fullName}
                               onChange={this.handleInputChange('fullName')}/>
                        {this.validator.message(pageTranslates.FullName, fullName, 'required|string')}
                    </>
                    }

                    <div className='text-center p-2'>
                        <small className='color-primary'>
                            {stringFormat(pageTranslates.SendTo, [mobile])}
                        </small>
                    </div>

                    {!sendAgain &&
                    <div style={{textAlign: 'center'}}>
                        <span style={{padding: '0 10px'}}>
                            {pageTranslates.TimeToSend}
                        </span>
                        <Timer initialTime={time} direction="backward"
                               checkpoints={[
                                   {
                                       time: 0,
                                       callback: this.endOfTimer,
                                   }
                               ]}>
                            <span>
                                <Timer.Minutes formatValue={(value) => `${(value < 10 ? `0${value}` : value)}`}/>
                                :
                                <Timer.Seconds formatValue={(value) => `${(value < 10 ? `0${value}` : value)}`}/>
                            </span>
                        </Timer>
                    </div>
                    }

                    <div className='pt-1 pb-1'>
                        {sendAgain
                            ?
                            <Button title={pageTranslates.SendAgain} full type='primary' onClick={this.sendAgainOnClick}
                                    loading={submitLoading}/>
                            : <Button full type='secondary' title={pageTranslates.Submit} onClick={this.verifyOnClick}
                                      loading={submitLoading}/>
                        }
                        <LinkButton to="/" full type='danger' title={pageTranslates.Back}/>
                    </div>
                </div>
            </div>
        );
    }
}

const ActionCreators = Object.assign({}, AvatarAction);

const mapDispatchToProps = dispatch => {
    return ({
        actions: bindActionCreators(ActionCreators, dispatch)
    });
};

const mapStateToProps = state => {
    const {locale} = state;
    return {locale};
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Verify));
